/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function GutenbergProductsBlock(elem) {
        Behaviors.init(GutenbergProductsBlock, this, arguments);

        var $thisElem = this.$elem;

        var $window = $(window);
        var produstSlider = $(".GutenbergProductsBlock-content_items");
        var produstSliderItem = $(".GutenbergProductsBlock-content_items > .GutenbergProductsBlock-content_items_item");
        var statusCounter = $('.GutenbergProductsBlock-content_pagination');

        // console.log(produstSliderItem.length);

        if (produstSliderItem.length > 1) {
            if( $window.width() > 1024 ) {
                produstSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + 1;
                    if(i < 10) {
                        var zeroSate = 0;
                    } else {
                        var zeroSate = '';
                    };
                    if(slick.slideCount < 10) {
                        statusCounter.html('<span>' + zeroSate + i + '</span>' + '/' + '<span>' + zeroSate + slick.slideCount + '</span>');
                    } else {
                        statusCounter.html('<span>' + zeroSate + i + '</span>' + '/' + '<span>' + slick.slideCount + '</span>');
                    };
                });
            } else {
                // console.log(produstSliderItem.length);
                if (produstSliderItem.length == 3 || produstSliderItem.length == 5 || produstSliderItem.length == 7 || produstSliderItem.length == 9 || produstSliderItem.length == 11 || produstSliderItem.length == 13 || produstSliderItem.length == 15) {
                    produstSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                        var i = (currentSlide ? currentSlide : 0) + 1;
                        if(i < 10) {
                            var zeroSate = 0;
                        } else {
                            var zeroSate = '';
                        };
                        if(slick.slideCount < 10) {
                            statusCounter.html('<span>' + zeroSate + i + '</span>' + '/' + '<span>' + zeroSate + slick.slideCount + '</span>');
                        } else {
                            statusCounter.html('<span>' + zeroSate + i + '</span>' + '/' + '<span>' + slick.slideCount + '</span>');
                        };
                    });
                } else {
                    produstSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                        if( $window.width() < 1025 &&  $window.width() > 767) {
                            if(currentSlide == undefined || currentSlide <= 2)  {
                                var i = (currentSlide ? currentSlide : 0) + 3;
                            } else {
                                var i = (currentSlide ? currentSlide : 0) + 2;
                            }
                        } else {
                            var i = (currentSlide ? currentSlide : 0) + 2;
                        }
                        // console.log(currentSlide);
                        if(i < 10) {
                            var zeroSate = 0;
                        } else {
                            var zeroSate = '';
                        };
                        if(slick.slideCount < 10) {
                            statusCounter.html('<span>' + zeroSate + i + '</span>' + '/' + '<span>' + zeroSate + slick.slideCount + '</span>');
                        } else {
                            statusCounter.html('<span>' + zeroSate + i + '</span>' + '/' + '<span>' + slick.slideCount + '</span>');
                        };
                    });
                }
                
            }
        }

        produstSlider.slick({
            dots: true,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: true,
            // fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<button type='button' class='slick-arrow-prev'><svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.875 10.09H3.125M8.75 4.465 3.125 10.09l5.625 5.625" stroke="#131314" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>`,
            nextArrow: `<button type='button' class='slick-arrow-next'><svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.167 10.09h11.666m0 0L10 4.257m5.833 5.833L10 15.923" stroke="#131314" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>`,
            // autoplaySpeed: 6000,
            // adaptiveHeight: false,
            adaptiveHeight: true,
            autoplay: false,
            responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    adaptiveHeight: true,
                    autoplay: false,
                    dots: false
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    adaptiveHeight: true,
                    autoplay: false,
                    dots: false
                  }
                }
              ]
        });

        if( $window.width() < 1025) {
            $(window).on('resize load', function(){

                var heights = {
                    'full' : {}
                };
        
                $("[data-equal]").css('height', 'auto');
                $("[class*='data-equal-']").css('height', 'auto');
        
                $("[data-equal], [class*='data-equal-']").each(function(){
        
                    var data_type = $(this).is("[class*='data-equal-']") ? 'class' : 'data';
        
                    if( data_type == 'data' ){
                        var $elem = $(this).attr('data-equal');
                        var size = $(this).attr('data-equal-width');
                    } else{
                        var classes = this.className.split(/\s+/);
        
                        for( var i = 0; i < classes.length; i++ ){
                            
                            var class_name = classes[ i ];
        
                            if( class_name.indexOf( 'data-equal-') > -1 ){
                                $elem = class_name.replace('data-equal-', '');
                            }
                            if( class_name.indexOf( 'data-equal-width-') > -1 ){
                                size = class_name.replace('data-equal-width-', '');
                            }
                        }
                    }
        
                    if( size == undefined )
                        size = 'full';
        
                    if( heights[ size ] == undefined ){
                        heights[ size ] = {}
                    }
        
                    if( heights[ size ][ $elem ] == undefined ){
                        heights[ size ][ $elem ] = 0;
                    }
        
                    var this_height = jQuery(this).outerHeight();
        
                    if( this_height > heights[ size ][ $elem ] ){
                        heights[ size ][ $elem ] = this_height;
                    }
                });
        
                var $window_width = $(window).outerWidth();
        
                for( var breakpoint in heights){
                    var element_data_value = heights[ breakpoint ];
        
                    for( var element in element_data_value ){
        
                        if( $window_width > parseInt(breakpoint) || breakpoint == 'full' ){
                            $("[data-equal='"+element+"'], [class*='data-equal-"+element+"']").css('height', element_data_value[ element ]);
                        }
                    }
                }
            });
        }

    }
    Behaviors.inherit(GutenbergProductsBlock, Behaviors.Behavior);
    GutenbergProductsBlock.QUERY = "[data-GutenbergProductsBlock]";
    GutenbergProductsBlock.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(GutenbergProductsBlock);
    module.GutenbergProductsBlock = GutenbergProductsBlock;
    return module;
}(window.jQuery, window.Behaviors));